export default "__VITE_ASSET__Bm_$x_OV__"